import React from 'react';

//import Scss
import './assets/scss/themes.scss';

import AOS from 'aos';
import 'aos/dist/aos.css';

//imoprt Route
import Route from './Routes';

// Import Firebase Configuration file
// import { initFirebaseBackend } from "./helpers/firebase_helper";

// const firebaseConfig = {
//   apiKey: process.env.REACT_APP_API_KEY,
//   authDomain: process.env.REACT_APP_AUTHDOMAIN,
//   databaseURL: process.env.REACT_APP_DATABASEURL,
//   projectId: process.env.REACT_APP_PROJECTID,
//   storageBucket: process.env.REACT_APP_STORAGEBUCKET,
//   messagingSenderId: process.env.REACT_APP_MESSAGINGSENDERID,
//   appId: process.env.REACT_APP_APPID,
//   measurementId: process.env.REACT_APP_MEASUREMENTID,
// };

// init firebase backend
// initFirebaseBackend(firebaseConfig);

function App() {
  
  AOS.init({
    easing: 'ease-out-back',
    duration: 2000,
    anchorPlacement: 'top-bottom', 
});

  return (
    <React.Fragment>
      <Route />
    </React.Fragment>
  );
}

export default App;
